import React, { Component, useContext } from "react";
import ReactModal from "react-modal";
import facebookIcon from "../../../assets/icons/facebook@3x.png";
import emailIcon from "../../../assets/icons/mail@3x.png";
import twitterIcon from "../../../assets/icons/twitter@3x.png";
import whatsappIcon from "../../../assets/icons/whatsapp@3x.png";
import { I18nContext } from "../../../providers/i18n";
import makeComparator from "../../../utils/percentagesComparator";
import { calculateResults } from "../../../utils/results-calculate";
import Button from "../../common/Button";
import VotingTitle from "../Title";
import BarChart from "./BarChart";
import QuestionsOverview from "./QuestionsOverview";
import Subtitle from "./QuestionsOverview/Subtitle";
import "./styles.scss";

ReactModal.setAppElement("#root");

const SHARE_TEXT = encodeURIComponent(
  "Hol dir die App gleich hier: Im Apple Store https://itunes.apple.com/us/app/votenow/id1450750592?l=de&ls=1&mt=8 oder bei Google Play https://play.google.com/store/apps/details?id=ch.easyvote.votenow."
);

const FACEBOOK_LINK = encodeURIComponent("https://votenow.easyvote.ch");

const SocialButtons = ({ className = "" }) => (
  <div className={`social-buttons ${className}`}>
    <a
      target={"_blank"}
      href={`http://www.facebook.com/sharer/sharer.php?u=${FACEBOOK_LINK}`}
    >
      <img className={"social-icon"} src={facebookIcon} alt={"facebook"} />
    </a>
    <a
      target={"_blank"}
      href={`https://twitter.com/intent/tweet?text=${SHARE_TEXT}`}
    >
      <img className={"social-icon"} src={twitterIcon} alt={"twitter"} />
    </a>
    <a target={"_blank"} href={`whatsapp://send?text=${SHARE_TEXT}`}>
      <img className={"social-icon"} src={whatsappIcon} alt={"whatsapp"} />
    </a>
    <a target={"_blank"} href={`mailto:?&body=${SHARE_TEXT}`}>
      <img className={"social-icon"} src={emailIcon} alt={"email"} />
    </a>
  </div>
);

const DetailsBlock = ({ onButtonClick, className = "" }) => {
  const { t } = useContext(I18nContext);
  return (
    <div className={`details-block ${className}`}>
      <span className={"text"}>{t("vote.results.showDetailsButton")}</span>
      <Button className={"button"} onClick={onButtonClick}>
        {t("ok")}
      </Button>
    </div>
  );
};

class Results extends Component {
  state = {
    showLoginRequiredModal: false,
    showDetailedResults: false,
    yesPercentage: 50,
    noPercentage: 50
  };

  static getDerivedStateFromProps({ answers, likes, questions }, prevState) {
    const { yesPercentage, noPercentage } = calculateResults(
      answers,
      questions,
      likes
    );

    return {
      ...prevState,
      yesPercentage: Number.isInteger(yesPercentage) ? yesPercentage : 50,
      noPercentage: Number.isInteger(noPercentage) ? noPercentage : 50
    };
  }

  closeLoginRequiredModal = () => {
    this.setState({
      showLoginRequiredModal: false
    });
  };

  handleDetailsButtonClick = () => {
    this.setState({ showDetailedResults: true });
  };

  buildDeviationDescription = (firstPercentage, secondPercentage, t) =>
    makeComparator(
      "",
      `${t("vote.results.youAgree")}${firstPercentage}%${t(
        "vote.results.withTemplateYes"
      )}`,
      `${t("vote.results.youDisagree")}${secondPercentage}%${t(
        "vote.results.withTemplateNo"
      )}`
    )(firstPercentage, secondPercentage);

  render() {
    const { questions, title } = this.props;
    const {
      showDetailedResults,
      noPercentage,
      yesPercentage,
      showLoginRequiredModal
    } = this.state;
    const areAnswersEmpty = false;
    return (
      <I18nContext.Consumer>
        {({ t }) => (
          <div className="Results">
            <VotingTitle title={title} className={"mb20 ph30"} />
            {!showDetailedResults && (
              <div className="result-message">
                {areAnswersEmpty
                  ? t("vote.results.noAnswers")
                  : t("vote.results.success")}
              </div>
            )}
            <Subtitle
              className={"mb20 ph30"}
              text={t("vote.results.yourAnswersResultIn")}
            />
            <div className={"bar-chart mb20"}>
              <BarChart
                noPercentage={noPercentage}
                yesPercentage={yesPercentage}
              />
            </div>
            {showDetailedResults && (
              <QuestionsOverview
                onQuestionClick={this.props.onQuestionClick}
                questions={questions}
                containerClassName={"ph30 mb20"}
              />
            )}
            <Subtitle
              className={"mb20 ph30"}
              text={this.buildDeviationDescription(
                yesPercentage,
                noPercentage,
                t
              )}
            />
            <SocialButtons className={"mb20"} />
            {!showDetailedResults && (
              <DetailsBlock
                className="ph30"
                onButtonClick={this.handleDetailsButtonClick}
              />
            )}
            <ReactModal
              isOpen={showLoginRequiredModal}
              onRequestClose={this.closeLoginRequiredModal}
              className={"LoginRequiredModal"}
            >
              <p className={"login-message"}>
                {t("webOnly.sidebar.not-logged-in")}{" "}
                <a href="https://www.easyvote.ch/">easyvote.ch</a>.
              </p>
            </ReactModal>
          </div>
        )}
      </I18nContext.Consumer>
    );
  }
}

export default Results;
